import React, { Component } from 'react'
import { withSitecoreContext, Text } from '@sitecore-jss/sitecore-jss-react';
import { withTranslation } from 'react-i18next';

import { throttle, isMobile } from "../utilities/FrontFunctions/AoxGlobalFrontFunctions"
import { getApiDatas } from "../utilities/FrontFunctions/AoxFrontFunctions"
import { postApiDatas } from "../utilities/FrontFunctions/AoxFrontFunctions"
import { trackGA4Event } from '../utilities/FrontFunctions/AoxTrackingFunctions'

import ObjRetour from "./inc/ObjRetour";
import ObjMesFormationsFiltre from './inc/ObjMesFormationsFiltre'
import ObjDirectComptoirDermato from './inc/ObjDirectComptoirDermato'
import ObjMenuThematiqueAside from './inc/ObjMenuThematiqueAside'
import ObjProductsRelatedAside from './inc/ObjProductsRelatedAside'
import ObjFavoriteFormationAside from './inc/ObjFavoriteFormationAside'
import ModalFormationsFav from "./inc/Modal/ModalFormationsFav"

import '../assets/css/0010_sections/0410_section_hero_formation.css'
import '../assets/css/0010_sections/0430_section_aside_content_formation.css'
import '../assets/css/0020_objects/0600_obj_menu_thematique_aside.css'
import '../assets/css/0020_objects/0800_obj_navigation_header_formation.css'

class PageTheme extends Component {
	constructor(props) {
		super(props)
		this.state = {
			isMobile: isMobile(),
		}
		this.handleWindowResizeMainHeader = this.handleWindowResizeMainHeader.bind(this)
		this.throttleWindowResizeMainHeader = throttle(this.handleWindowResizeMainHeader, 200)
		this.handleButtonFav = this.handleButtonFav.bind(this)
	}
	handleWindowResizeMainHeader() {
		this.setState({
			isMobile: isMobile()
		})
	}
    
    fetchData = () => {
        const { scDatas } = this.props.fields.data;

        let params = `sThemeId=${scDatas.id}&sBrandCode=${scDatas.ListBrand[0]?.codeAbbrege.value}`;
        const datasScParcours1 = scDatas.ListBrand[0]?.ListParcoursFolder[0]?.ListParcours[0];
        if(datasScParcours1){
            params += "&sParcours1Id=" + datasScParcours1.id;
        }

        getApiDatas(`/apiaox/Call/PageTheme?${params}`).then((apiDatas) => { 
            this.setState({ apiDatas:apiDatas })
            window.scrollTo(0,0)
        })
    };

	componentDidMount() {
        this.fetchData();
	}
    
    componentDidUpdate(prevProps) {
        // contrôle que sur le ThemeId; dans les ScDatas, ThemeId => BrandCode, donc si le BrandCode a changé, le ThemeId a changé
        if (this.props.fields.data?.scDatas?.id !== prevProps.fields.data?.scDatas?.id) {
            this.fetchData();
        }
    }
    
    handleButtonFav(id) {
        //pushs possibles sur le parcours1, les formations, plus loin
        //!! liste des favori à gérer pour le aside
        var datasTraining = this.state.apiDatas.Parcours1.Formations.find(t => t.Training_ItemTraining_Id === id);
        if(!datasTraining){ datasTraining = this.state.apiDatas.ThemeFormations.find(t => t.Training_ItemTraining_Id === id); }
        if(!datasTraining){ datasTraining = this.state.apiDatas.ThemeAutresFormations.find(t => t.Training_ItemTraining_Id === id); }
        if(datasTraining){
            if(!datasTraining.Training_IsFavorite){
                //ajouter favori
                document.body.classList.add('is-loading')
                trackGA4Event(window.trackDatas, "training_add_favorite", "training", "training add favorite", "star icon");
                postApiDatas(`/apiaox/Call/AddTrainingFavorite?sIdTraining=${id}`, {})
                .then((res) => {
                    document.body.classList.remove('is-loading')
                    if (!res.IsValid) { alert(res.Message) }
                    else {
                        let newDatas = this.state.apiDatas;

                        //switcher le statut sur les listes
                        newDatas.Parcours1.Formations.forEach(t => {if(t.Training_ItemTraining_Id === id){t.Training_IsFavorite = true}});
                        newDatas.ThemeFormations.forEach(t => {if(t.Training_ItemTraining_Id === id){t.Training_IsFavorite = true}});
                        newDatas.ThemeAutresFormations.forEach(t => {if(t.Training_ItemTraining_Id === id){t.Training_IsFavorite = true}});

                        //ajouter à la liste des favoris
                        datasTraining.Training_IsFavorite = true; newDatas.TrainingsFavorite.unshift(datasTraining);

                        this.setState({ apiDatas: newDatas })
                        
                        if(!localStorage.getItem('dontShowAgainModalMAJFormationsFav')){
                            this.ModalFormationsFav.openModal();
                        }
                    }
                });
            } else {
                //supprimer favori
                document.body.classList.add('is-loading')
                postApiDatas(`/apiaox/Call/RemoveTrainingFavorite?sIdTraining=${id}`, {})
                .then((res) => {
                    document.body.classList.remove('is-loading')
                    if (!res.IsValid) { alert(res.Message) }
                    else {
                        let newDatas = this.state.apiDatas;

                        //switcher le statut sur les listes
                        newDatas.Parcours1.Formations.forEach(t => {if(t.Training_ItemTraining_Id === id){t.Training_IsFavorite = false}});
                        newDatas.ThemeFormations.forEach(t => {if(t.Training_ItemTraining_Id === id){t.Training_IsFavorite = false}});
                        newDatas.ThemeAutresFormations.forEach(t => {if(t.Training_ItemTraining_Id === id){t.Training_IsFavorite = false}});

                        //supprimer des favoris
                        newDatas.TrainingsFavorite = this.state.apiDatas.TrainingsFavorite.filter(t => t.Training_ItemTraining_Id !== id);

                        this.setState({ apiDatas: newDatas })
                    }
                });
            }
        }
    }

	render() {
        const pageDatas = this.props.sitecoreContext.route?.fields;
        const { scDatas , scDatasComptoir} = this.props.fields.data;
        const { apiDatas } = this.state;

		return (<>{ pageDatas &&scDatas && apiDatas && <>
			<section className="obj_section section_hero_formation">
				<div className="ctn_section">
					<div className="ctn_text">
                        <Text className="t_title" field={pageDatas["Page Title"]} tag="h1"></Text>
                        { !this.state.isMobile && <ObjRetour/> }
					</div>
				</div>
			</section>

			<section className="obj_section section_aside_content">
				<div className="ctn_section">
					<div className="ctn_columns">

						<div className="ctn_content">
							{apiDatas.ThemeFormations && <ObjMesFormationsFiltre datasTrainings={apiDatas.ThemeFormations} dataThemeTitle={scDatas.pageTitle} handleButtonFav={this.handleButtonFav}/>}
							{apiDatas.ThemeAutresFormations && <ObjDirectComptoirDermato datasTrainings={apiDatas.ThemeAutresFormations} dataType="Theme" datasComptoir={scDatasComptoir} handleButtonFav={this.handleButtonFav}/>}
						</div>

						<div className="ctn_aside">
						    {scDatas.ListBrand[0]?.ListThemeFolder[0]?.ListTheme && <ObjMenuThematiqueAside datasThemes={scDatas.ListBrand[0].ListThemeFolder[0].ListTheme} themeId={scDatas.id}/>}
							{apiDatas.TrainingsFavorite?.length >0 && <ObjFavoriteFormationAside datasTrainings={apiDatas.TrainingsFavorite}/>}
						    {scDatas.produitsAssocies?.targetItems?.length > 0 && <ObjProductsRelatedAside datasProduits={scDatas.produitsAssocies.targetItems}/>}
						</div>

					</div>
				</div>
			</section>

            <ModalFormationsFav 
                onRef={ref => (this.ModalFormationsFav = ref)} 
                modalTitle=""
                modalText="Vous venez d'ajouter cette formation à votre liste de favoris"
                modalCtaText="Retrouver mes favoris"
            />
        </>}</>)
    }
}

export default withTranslation()(withSitecoreContext()(PageTheme));